// extracted by mini-css-extract-plugin
module.exports = {"slider":"NewCarModelSlider_slider__yytnb","car":"NewCarModelSlider_car__KGkOm"};